"use client";

import * as PrimitiveToast from "@radix-ui/react-toast";

import { Icon } from "@/components/ui/icon";
import { useToast, UseToastProps } from "./use-toast";

export type ToastProps = UseToastProps;

function Toast(props: ToastProps) {
  const { className, styles, isOpen, message, type, onToastChange } = useToast(props);

  return (
    <>
      <PrimitiveToast.Root
        open={isOpen}
        onOpenChange={onToastChange}
        duration={5000}
        className={styles.base({ className })}
      >
        <PrimitiveToast.Description className={styles.description()}>
          <Icon name="checked_circle" className="size-5 text-brand-accent" />
          {message}
        </PrimitiveToast.Description>
      </PrimitiveToast.Root>

      <PrimitiveToast.Viewport className={styles.viewport()} />
    </>
  );
}

export default Toast;
